import { jobPostingServiceApi } from '@/api/job-posting-service-api'
import { type MutationConfig } from '@/lib/react-query'
import { useHandleQueryError } from '@/utils/error'
import { useMutation, type UseMutationResult } from '@tanstack/react-query'
import {
  type FetchError,
  type JobPostingServicePostActionOperationRequest
} from 'mnvm-mypage-app-ts-if'

export const jobPostingServicePostAction = async (
  requestParameters: JobPostingServicePostActionOperationRequest
): Promise<object> => {
  return await jobPostingServiceApi.jobPostingServicePostAction(
    requestParameters
  )
}

interface UseJobPostingServicePostActionOptions {
  config?: MutationConfig<typeof jobPostingServicePostAction>
}

export const jobPostingServicePostActionMutationKey: string =
  'job_posting_service_post_action'

export const useJobPostingServicePostAction = ({
  config
}: UseJobPostingServicePostActionOptions = {}): UseMutationResult<
  object,
  FetchError,
  JobPostingServicePostActionOperationRequest,
  unknown
> => {
  const handleError = useHandleQueryError()
  return useMutation({
    mutationKey: [jobPostingServicePostActionMutationKey],
    onError: (err) => {
      handleError(err).catch((error) => {
        console.error('Failed to handle error:', error)
      })
      return err
    },
    ...config,
    mutationFn: jobPostingServicePostAction
  })
}
